<template>
  <li
    class="issue-card selectable"
    :class="{ picked: selected, applying, fixed, locked: fixed || disabled }"
    @click="onClick"
  >
    <div class="issue-check"><svg v-if="selected || fixed" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg></div>
    <div class="issue-body">
      <div class="issue-title">{{ issue.title }}</div>
      <div class="issue-rec">{{ issue.description }}<span v-if="issue.recommended_fix"> Recommended fix: {{ issue.recommended_fix }}</span></div>
    </div>
    <span class="issue-cost" :class="{ free: !issue.cost }">{{ issue.cost ? '⚡ 1 credit' : '✓ Free' }}</span>
  </li>
</template>

<script>
export default {
  name: "AiwV2IssueCard",
  props: {
    issue: { type: Object, required: true },
    // Whether this fix is currently selected to run.
    selected: { type: Boolean, default: false },
    // True while a fix run is applying (cards lock/dim; the .fixprog panel above
    // the list is the only progress UI — no per-card loading bar).
    applying: { type: Boolean, default: false },
    // True once this fix has been applied (done state — green check, locked).
    fixed: { type: Boolean, default: false },
    // True when the fixes are globally locked (all fix runs used) — card is inert.
    disabled: { type: Boolean, default: false },
  },
  methods: {
    onClick() {
      if (this.applying || this.fixed || this.disabled) return;
      this.$emit("toggle-select", this.issue);
    },
  },
};
</script>

<style scoped>
.issue-card { background: #fff; border: 1px solid var(--border, #e4e4e4); border-radius: var(--r-lg, 10px); padding: 14px 16px; display: flex; gap: 12px; align-items: flex-start; list-style: none; }
.issue-card.selectable { cursor: pointer; transition: border-color .12s, background .12s, box-shadow .12s; }
.issue-card.selectable:hover { border-color: var(--border-strong, #ccc); }
.issue-card.picked { border-color: var(--border-strong, #ccc); background: #fff; }
.issue-card.applying { cursor: default; opacity: .85; }
.issue-card.locked { cursor: default; }
.issue-card.fixed { background: var(--pop-green-soft, #e0f5ec); border-color: var(--pop-green-soft, #b9e6d3); }
.issue-check { width: 20px; height: 20px; border-radius: 6px; border: 1.5px solid var(--border-strong, #ccc); background: #fff; flex-shrink: 0; display: flex; align-items: center; justify-content: center; color: #fff; margin-top: 1px; transition: all .12s; }
.issue-card.picked .issue-check { background: var(--pop-orange, #ff5700); border-color: var(--pop-orange, #ff5700); }
.issue-card.fixed .issue-check { background: var(--pop-green, #25a97a); border-color: var(--pop-green, #25a97a); }
.issue-check svg { width: 13px; height: 13px; }
.issue-body { flex: 1; min-width: 0; }
.issue-title { font-weight: 700; font-size: 13.5px; color: var(--text, #052e33); margin-bottom: 2px; }
.issue-rec { font-size: 12.5px; color: var(--text-3, #6b7b7e); line-height: 1.5; }
.issue-cost { flex-shrink: 0; display: inline-flex; align-items: center; gap: 4px; font-size: 11px; font-weight: 700; color: var(--text-2, #014751); background: var(--surface-2, #f7f7f7); border-radius: 100px; padding: 2px 8px; white-space: nowrap; }
.issue-cost.free { color: var(--pop-green, #25a97a); background: var(--pop-green-soft, #e0f5ec); }
</style>
